import React from 'react';
import {useParams} from 'react-router-dom';
import useFilterModalContext from '../../useFilterModalContext';
import useSearchParams from '../../../../useSearchParams';
import {XMarkIcon, ArrowRightIcon} from '@heroicons/react/20/solid';
import {usePoolQuery} from 'api';
import {getTagFontColor} from 'helpers/tagColors';

export default () => {
  const {setFilterType} = useFilterModalContext();
  const {query, setQuery} = useSearchParams();
  const {poolId} = useParams<{poolId: string}>();

  const {data: {pool: {prospectTags = []} = {}} = {}} = usePoolQuery({
    variables: {uuid: poolId},
    fetchPolicy: 'cache-and-network',
  });

  if (!query?.excludedTagIds || !query.excludedTagIds.length) {
    return null;
  }

  return (
    <div className="pb-4 border-b border-c-border flex flex-col gap-2">
      <div className="flex items-center gap-1">
        <h4 className="m-0 font-bold">タグ（含まない）</h4>
        <button
          onClick={() => setFilterType('excludedTag')}
          className="p-0 h-5 w-5 flex items-center justify-center rounded-full border border-c-lighter cursor-pointer">
          <ArrowRightIcon className="w-3 h-3 text-c-light" />
        </button>
        <button
          onClick={() => setQuery({...query, excludedTagIds: []})}
          className="p-0 h-5 w-5 flex items-center justify-center rounded-full border border-c-lighter cursor-pointer">
          <XMarkIcon className="w-3 h-3 text-c-light" />
        </button>
      </div>
      <div className="flex gap-1">
        <div className="flex flex-wrap items-center">
          {prospectTags
            .filter((tag) => query.excludedTagIds.includes(tag.id))
            .map((tag) => (
              <span
                color={tag.color}
                key={tag.id}
                className="mr-1.5 mb-1.5 flex px-[7px] py-[3px] rounded-sm"
                style={{background: tag.color}}>
                <span
                  className="text-sm font-bold leading-4 tracking-[0.15px]"
                  style={{color: getTagFontColor(tag.color)}}>
                  {tag.name}
                </span>
              </span>
            ))}
        </div>
      </div>
    </div>
  );
};
